import styles from './About.module.css';

/**
 * About Page Component
 * 
 * Displays:
 * - Disclaimer
 * - Copyright information
 * - Octocat image
 * - List of app features
 */
export function About() {
  return (
    <div className={styles.aboutPage}>
      <div className={styles.container}>
        <header className={styles.header}>
          <img 
            src="/octocat.png" 
            alt="S3-D1 Octocat" 
            className={styles.octocat}
          />
          <h1 className={styles.title}>About Iron Makers Day App</h1>
        </header>

        <section className={styles.section}>
          <h2>Disclaimer</h2>
          <p>
            This application is provided "as is" without warranty of any kind, express or implied. 
            The information and features are designed for the Iron Makers Day @ one:demo forge event 
            and may be subject to changes. Use at your own discretion.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Copyright & Attribution</h2>
          <p>
            © 2026 <a href="https://github.com/S3-D1" target="_blank" rel="noopener noreferrer">S3-D1</a>
          </p>
          <p>
            This project is open source and available under the MIT License.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Features</h2>
          <ul className={styles.featureList}>
            <li>
              <strong>🔥 Dark Theme with Metallic Aesthetics</strong>
              <p>Immersive dark mode with fire accents and industrial design elements</p>
            </li>
            <li>
              <strong>📱 Responsive Design</strong>
              <p>Optimized for both mobile and desktop viewing experiences</p>
            </li>
            <li>
              <strong>⏱️ Live Agenda Tracker</strong>
              <p>Real-time countdown timer showing current and upcoming agenda items</p>
            </li>
            <li>
              <strong>💪 Power Break Feature</strong>
              <p>Quick 180-second team synchronization breaks with visual countdown</p>
            </li>
            <li>
              <strong>🎯 Challenge Tracking</strong>
              <p>Monitor Forge Challenge progress and Side Quests completion</p>
            </li>
            <li>
              <strong>☁️ State Synchronization</strong>
              <p>AWS S3 integration for persistent state across devices and sessions</p>
            </li>
            <li>
              <strong>🎨 Time-Based Visibility</strong>
              <p>Sections automatically show/hide based on event schedule</p>
            </li>
            <li>
              <strong>🚀 Pre-Event Countdown</strong>
              <p>Displays countdown to event start before the hackathon begins</p>
            </li>
            <li>
              <strong>👥 Team Display</strong>
              <p>Showcase participating teams with randomization support</p>
            </li>
            <li>
              <strong>⚡ Fast Performance</strong>
              <p>Built with Vite for lightning-fast development and optimized production builds</p>
            </li>
            <li>
              <strong>🧪 Comprehensive Testing</strong>
              <p>Unit tests, integration tests, and property-based testing with fast-check</p>
            </li>
            <li>
              <strong>🎭 Splash Screen</strong>
              <p>Engaging welcome screen with event branding</p>
            </li>
          </ul>
        </section>

        <section className={styles.section}>
          <h2>Technology Stack</h2>
          <ul className={styles.techList}>
            <li>React 18+ with TypeScript</li>
            <li>Vite Build Tool</li>
            <li>CSS Modules with Custom Properties</li>
            <li>React Context API for State Management</li>
            <li>AWS S3 for State Persistence</li>
            <li>Vitest + React Testing Library</li>
            <li>GitHub Actions for CI/CD</li>
          </ul>
        </section>

        <footer className={styles.footer}>
          <a href="/" className={styles.backLink}>← Back to Event</a>
        </footer>
      </div>
    </div>
  );
}
